import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsDownloadAppraisalsAndReceiptsForJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
      selectedJobsZipping: false,
    };
    this.downloadAppraisalsAndReceiptsForJob = this.downloadAppraisalsAndReceiptsForJob.bind(this);
    this.downloadZIP = this.downloadZIP.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  downloadAppraisalsAndReceiptsForJob(e) {
    e.preventDefault();
    if (this.state.selectedJobsZipping) return;
    this.setState({
      selectedJobsZipping: true
    });
    return fetch(
      '/api/v1/portal/appraisal-expense-invoice-info/job/' + this.state.data.id + '/combined-appraisal-expense-zip-download',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
        },
        body: JSON.stringify({
          jobsToIncludeInZip: this.state.data.id,
        }),
      }
    ).then((responseText) => {
      return responseText.json();
    }).then((customerJobZip) => {
      if (customerJobZip.zip) {
        this.downloadZIP(customerJobZip.zip);
      } else {
        alert('No zip file found for download.');
        this.setState({
          selectedJobsZipping: false
        });
      }
    }).catch((error) => {
      console.error('Error fetching zip file:', error);
      alert('There was an error downloading the zip file.');
      this.setState({
        selectedJobsZipping: false
      });
    });
  }

  downloadZIP(zipFile) {
    this.setState({
      selectedJobsZipping: false
    });
    const a = document.createElement('a');
    a.href = zipFile;
    a.download = zipFile.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  render() {
    return (
      <a
        href="#"
        onClick={this.downloadAppraisalsAndReceiptsForJob}
        className="btn btn-lg btn-success"
        disabled={this.state.selectedJobsZipping === true}
      >
        <i className="fa fa-download"></i> Download Appraisals and Receipts For Job
      </a>
    );
  }
}